var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 21.875V43.75H0V21.5625C0 6.5625 14.0625 4.6875 14.0625 4.6875L15.9375 9.0625C15.9375 9.0625 9.6875 10 8.4375 15C7.1875 18.75 9.6875 21.875 9.6875 21.875H21.875ZM50 21.875V43.75H28.125V21.5625C28.125 6.5625 42.1875 4.6875 42.1875 4.6875L44.0625 9.0625C44.0625 9.0625 37.8125 10 36.5625 15C35.3125 18.75 37.8125 21.875 37.8125 21.875H50Z",
    fill: "#77090A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/Quote.40c6b70286f085922178ff845c264096.svg";
export { ForwardRef as ReactComponent };